class YSWEstimatedArrival extends HTMLElement {
  constructor() {
    super();
    this.estimatedDate = this.querySelector("[data-date]") || null;
    this.estimatedDateExpress =
      this.querySelector("[data-express-date]") || null;
    // this.arrivalDate = this.querySelector("[data-express-arrival-date]") || null;
    this.storeData = {
      timezone: "America/Menominee",
      hours: 3,
      minutes: 0,
      seconds: 0,
      maxDayExpected: 9,
      minDayExpected: 7,
      expressDayExpected: 2,
      holidays: [],
    };
    this.setHolidays();
    this.ready();
  }

  /**
   * Executes once the DOM is ready
   * @returns {void}
   */
  ready() {
    document.addEventListener("DOMContentLoaded", async () => {
      let now = this.convertTimeZone(new Date(), this.storeData.timezone);
      let currentDay = null;
      let maxStandard = this.getArrivalDate(this.storeData.maxDayExpected);
      let minStandard = this.getArrivalDate(this.storeData.minDayExpected);
      let express = this.getArrivalDate(this.storeData.expressDayExpected);
      let standardExtraDays = 0;
      let expressExtraDays = 0;

      if (maxStandard.formatedDate === minStandard.formatedDate) {
        standardExtraDays = standardExtraDays + 2;
        maxStandard = this.getArrivalDate(
          this.storeData.maxDayExpected + standardExtraDays
        );
      }

      //Avoid weekends as transit days
      if (this.isAboveTime(now)) {
        now.setDate(now.getDate() + 1);
        currentDay = now.toLocaleString("en-US", { weekday: "long" });
        if (currentDay === "Saturday") {
          expressExtraDays = expressExtraDays + 2;
          express = this.getArrivalDate(
            this.storeData.expressDayExpected + expressExtraDays
          );
        } else if (currentDay === "Sunday") {
          expressExtraDays = expressExtraDays + 1;
          express = this.getArrivalDate(
            this.storeData.expressDayExpected + expressExtraDays
          );
        }
      }

      this.setElementContent(
        this.estimatedDate,
        `${minStandard.formatedDate} -<br/> ${maxStandard.formatedDate}`
      );
      this.setElementContent(
        this.estimatedDateExpress,
        `${express.formatedDate}`
      );

      // if (maxStandard.month == minStandard.month) {
      //   this.setElementContent(
      //     this.arrivalDate,
      //     `${minStandard.month} ${minStandard.day} - ${maxStandard.day}`
      //   );
      // } else {
      //   this.setElementContent(
      //     this.arrivalDate,
      //     `${minStandard.month} ${minStandard.day} - ${maxStandard.month} ${maxStandard.day}`
      //   );
      // }

      this.setGraphicDates(`${maxStandard.month} ${maxStandard.day}`);
    });
  }

  /**
   * Gets the arrival date from the store data
   * @param {Integer} daysExpected the number of days expected to arrive
   * @returns {Object} the arrival dates
   */
  getArrivalDate(daysExpected) {
    let modifier = 0;
    let warehouseDate = this.convertTimeZone(
      new Date(),
      this.storeData.timezone
    );

    warehouseDate.setHours(
      this.storeData.hours,
      this.storeData.minutes,
      this.storeData.seconds
    );
    let date = warehouseDate.getDate();

    if (this.isAboveTime(warehouseDate)) modifier = 1;

    warehouseDate.setDate(date + (daysExpected + modifier));

    //avoid weekends
    warehouseDate = this.withoutWeekends(warehouseDate);

    //Avoid holidays
    warehouseDate = this.withoutHolidays(warehouseDate);

    //Avoid weekends
    warehouseDate = this.withoutWeekends(warehouseDate);

    let day = warehouseDate.toLocaleString("en-US", { day: "2-digit" });
    let month = warehouseDate.toLocaleString("en-US", { month: "long" });
    let weekDay = warehouseDate.toLocaleString("en-US", { weekday: "long" });
    let year = warehouseDate.toLocaleString("en-US", { year: "numeric" });

    return {
      weekDay,
      day,
      month,
      year,
      formatedDate: `${weekDay}, ${month} ${day}`,
    };
  }

  /**
   * Gets the arrival date from the store data
   * @returns {Object} the arrival dates
   */
  getShipDate() {
    let modifier = 0;
    let warehouseDate = this.convertTimeZone(
      new Date(),
      this.storeData.timezone
    );

    warehouseDate.setHours(
      this.storeData.hours,
      this.storeData.minutes,
      this.storeData.seconds
    );
    let date = warehouseDate.getDate();

    if (this.isAboveTime(warehouseDate)) modifier = 1;

    warehouseDate.setDate(date + modifier);

    //avoid weekends
    warehouseDate = this.withoutWeekends(warehouseDate);

    //Avoid holidays
    warehouseDate = this.withoutHolidays(warehouseDate);

    //Avoid weekends
    warehouseDate = this.withoutWeekends(warehouseDate);

    let day = warehouseDate.toLocaleString("en-US", { day: "2-digit" });
    let month = warehouseDate.toLocaleString("en-US", { month: "long" });
    let weekDay = warehouseDate.toLocaleString("en-US", { weekday: "long" });
    let year = warehouseDate.toLocaleString("en-US", { year: "numeric" });

    return {
      weekDay,
      day,
      month,
      year,
      formatedDate: `${weekDay}, ${month} ${day}`,
    };
  }

  /**
   * @param {NodeElement} element to set the content
   * @param {String} content to be displayed at the element
   */
  setElementContent(element, content) {
    if (!element) return false;
    element.innerHTML = content;
  }

  /**
   * Set the holidays array from the store data
   * check if the custom component has the data-holidays attribute,
   * if not, look for a script tag with the data-holidays attribute
   * and set the holidays array from the script tag
   */
  setHolidays() {
    let holidays = this.dataset.holidays;

    if (holidays != "") {
      this.storeData.holidays = holidays.split(",");
    } else {
      let docHoliday = document.querySelector("script[data-holidays]");

      if (!docHoliday) return;
      this.storeData.holidays = docHoliday.dataset.holidays.split(",");
    }
  }

  /**
   * Validate if date is weekend day and set it to two days ahead
   * @param {Date} date to convert
   * @param {Integer} days to add
   * @returns {Date} the converted date
   */
  withoutWeekends(date, days = 2) {
    if (date.getDay() === 0 || date.getDay() === 6)
      date.setDate(date.getDate() + days);

    return date;
  }

  /**
   * Validate if date is a holiday and set it to the next day
   * @param {Date} date to convert
   * @param {Integer} days to add
   * @returns {Date} the converted date
   */
  withoutHolidays(date, days = 1) {
    let month = date.toLocaleString("en-US", { month: "long" });
    let day = date.toLocaleString("en-US", { day: "2-digit" });
    let shortDate = `${month} ${day}`.toLowerCase();
    let holidays = this.storeData.holidays;

    for (let index = 0; index < holidays.length; index++) {
      let holiday = holidays[index].trim().toLowerCase();

      if (shortDate.indexOf(holiday) > -1 && holiday !== "") {
        date.setDate(date.getDate() + days);
      }
    }

    return date;
  }

  /**
   * Fill the shipping estimated arrival graphic
   * @param {String} arrival date as string to be displayed as arrival date
   */
  setGraphicDates(arrival) {
    const orderDate = this.querySelector("[data-order-date]");
    const shipsDate = this.querySelector("[data-ships-date]");
    const arrivalDate = this.querySelector("[data-arrival-date]");
    const today = new Date(
      this.convertTimeZone(new Date(), this.storeData.timezone)
    );
    let month = today.toLocaleString("en-US", { month: "long" });
    let day = today.toLocaleString("en-US", { day: "2-digit" });

    const shipEstimate = this.getShipDate();

    this.setElementContent(orderDate, `${month} ${day}`);
    this.setElementContent(
      shipsDate,
      `${shipEstimate.month} ${shipEstimate.day}`
    );
    this.setElementContent(arrivalDate, arrival);
  }

  /**
   * Converts a date to a given timezone
   * @param {Date} date the date to be converted
   * @param {String} timezone the timezone to convert the date to
   * @returns {Date} the converted date
   */
  convertTimeZone(date, timezone) {
    const dateString = date.toLocaleString("en-US", {
      timeZone: timezone,
    });
    return new Date(dateString);
  }

  /**
   * Compares the current time to a given time
   * @param {Date} date the date to check if it is after the current date
   * @returns {Boolean} true if the date is after the current date, false otherwise
   */
  isAboveTime(date) {
    let now = this.convertTimeZone(new Date(), this.storeData.timezone);

    return Date.parse(now) >= Date.parse(date);
  }
}

customElements.define("estimated-arrival", YSWEstimatedArrival);
